import { Button, ButtonProps } from "@mui/material";
import { ReactElement } from "react";

interface ActionButtonProps extends Omit<ButtonProps, "startIcon" | "endIcon"> {
  icon?: ReactElement;
  iconPosition?: "start" | "end";
  variant?: "contained" | "outlined" | "text";
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success" | "inherit";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export default function ActionButton({
  icon,
  iconPosition = "start",
  variant = "outlined",
  color = "primary",
  size = "small",
  disabled = false,
  onClick,
  children,
  sx,
  ...props
}: ActionButtonProps) {
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      disabled={disabled}
      onClick={onClick}
      startIcon={iconPosition === "start" ? icon : undefined}
      endIcon={iconPosition === "end" ? icon : undefined}
      sx={{
        py: 0.5,
        px: 1.5,
        fontSize: "0.75rem",
        textTransform: "none",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
